import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const NameInput = React.forwardRef(
    ({ value, onChange, onClick, onKeyUp, containerRef }, ref) => {
        const { t } = useTranslation('customer');
        return (
            <div
                data-name
                data-icon-before
                className="m2g-customer-name-input-container m2g-input-container m2g-form-element--full-width"
                onClick={onClick}
                role="presentation"
                ref={containerRef}
            >
                <input
                    type="text"
                    className="m2g-customer-name-input m2g-input m2g-form-element--full-width"
                    placeholder={t('full_name_placeholder')}
                    value={value}
                    onChange={e => onChange && onChange(e.target.value)}
                    onKeyUp={onKeyUp}
                    name="name"
                    autoComplete="name"
                    ref={ref}
                />
                <span className="m2g-icon m2g-icon--user" />
            </div>
        );
    }
);

NameInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onKeyUp: PropTypes.func,
    containerRef: PropTypes.func,
};

NameInput.defaultProps = {
    onChange: null,
    onClick: null,
    onKeyUp: null,
    containerRef: null,
};

export default NameInput;
